import {
    Box,
    chakra,
    Container,
    Stack,
    HStack,
    Link,
    useColorModeValue,
    VisuallyHidden,
    Text,
  } from '@chakra-ui/react';
  import { FaTwitter, FaTelegramPlane, FaDiscord, FaMedium } from 'react-icons/fa';
  import { ReactNode } from 'react';
  import logo from "../images/logo-64.svg"

  const SocialButton = ({
    children,
    label,
    href,
  }: {
    children: ReactNode;
    label: string;
    href: string;
  }) => {
    return (
      <chakra.button
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        w={8}
        h={8}
        cursor={'pointer'}
        as={'a'}
        href={href}
        display={'inline-flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'background 0.3s ease'}
        _hover={{
          bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
        }}>
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
      </chakra.button>
    );
  };

  export default function Footer() {
    return (
      <Box
        bg={useColorModeValue('gray.200', 'gray.900')}
        color={useColorModeValue('gray.700', 'gray.200')}>
        <Stack
          py={4}
          textAlign={'center'}
        >
          <Text justifySelf={'center'} >© Copyright 2022 Crangon - All Rights Reserved</Text>
          {/* <Stack direction={'row'} spacing={6}>
            <SocialButton label={'Twitter'} href={'#'}>
              <FaTwitter />
            </SocialButton>
            <SocialButton label={'Telegram'} href={'#'}>
              <FaTelegramPlane />
            </SocialButton>
            <SocialButton label={'Discord'} href={'#'}>
              <FaDiscord />
            </SocialButton>
            <SocialButton label={'Medium'} href={'#'}>
              <FaMedium />
            </SocialButton>
          </Stack> */}
        </Stack>
      </Box>
    );
  }
